



















































































import {
  defineComponent, reactive, computed, ref,
} from '@vue/composition-api';
import { useRouter, useFormat } from '@ideavivat/vivat-2';

import PanelWithCopyEntity from '@/components/PanelWithCopyEntity.vue';

import CommonConfirmDialog from '@/components/Dialog/CommonConfirmDialog.vue';

import knowledge from '@/table/knowledge';

import i18n from '@/i18n';

import getHandicraftTypes from '@/gql/getHandicraftTypes.gql';
import getKnowledges from '@/gql/getKnowledges.gql';
import deleteKnowledge from '@/gql/deleteKnowledge.gql';
import { useQuery, useResult, useMutation } from '@vue/apollo-composable';

const List = defineComponent({
  setup() {
    // ==== Redirect to view item page ==== //
    const { router } = useRouter();
    const { route } = useRouter();
    function viewItem(item: any) {
      router.push({ name: 'KnowledgeView', params: { knowledgeId: item.item?.id } });
    }

    const getKnowledgesResult = (data: any) => data.knowledges;

    /* ==== Get Handicraft Type ==== */
    const { result: handicraftTypeResult } = useQuery(getHandicraftTypes);
    const handicraftTypes = useResult(handicraftTypeResult, [], (data) => data.handicraftTypes);

    const search = reactive({
      text: '',
    });

    // const selectedHandicraftTypeId = reactive(undefined);

    // ==== After integrate w/ api ==== //
    // Query Knowledge by handicraftTypeId //

    // ==== Set message to display on delete dialog ==== //
    const deleteItem = reactive({
      id: '',
      name: '',
    });
    function setDisplayItem(item: any) {
      deleteItem.id = item.id;
      deleteItem.name = item.name;
    }
    // ==== Create delete Mutation ==== //
    const deleteMutation = useMutation(
      deleteKnowledge,
      () => ({
        variables: {
          id: deleteItem.id,
        },
        refetchQueries: ['getHandicraftTypes', 'getKnowledges'],
      }),
    );

    // ==== Use to search Handicraft ==== //
    const knowledgesVariable = computed(() => {
      const vars: {[key: string]: any} = {
        filterHandicraftType: parseInt(route.value.params.handicraftTypeId, 10),
        searchName: undefined,
      };
      if (search.text) {
        vars.searchName = `%${search.text}`;
      }
      return vars;
    });

    function dateFormat(date: string) {
      return useFormat.date(date).displayShortThaiDate();
    }

    const copyingItem = ref({});

    return {
      copyingItem,
      deleteItem,
      deleteMutation,
      knowledgeTableOption: knowledge,
      handicraftTypes,
      search,
      setDisplayItem,
      viewItem,
      getKnowledgesResult,
      getKnowledges,
      dateFormat,
      knowledgesVariable,
      i18n,
    };
  },
  components: {
    PanelWithCopyEntity,
    CommonConfirmDialog,
  },
  props: {
    role: {},
  },
});

export default List;
